import { render, staticRenderFns } from "./SearchModeSwitchButton.vue?vue&type=template&id=5d51e460&scoped=true&"
import script from "./SearchModeSwitchButton.vue?vue&type=script&lang=ts&"
export * from "./SearchModeSwitchButton.vue?vue&type=script&lang=ts&"
import style0 from "./SearchModeSwitchButton.vue?vue&type=style&index=0&id=5d51e460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51e460",
  null
  
)

export default component.exports